export default __webpack_public_path__ + "static/media/station-list-icon.9009ecd1.svg";